import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';
import { AppointmentsResponseInterface } from '../../../interfaces/response/appointments/appointments-response-interface';
import { CpAppointmentsModel } from '../../dto/appointments/cp-appointments-model';

export class CpAppointmentsResponseModel implements AppointmentsResponseInterface {
  appointmentList: CpAppointmentsModel[] = new Array<CpAppointmentsModel>();
  pagination: PaginationModel = new PaginationModel();

  constructor(init?: Partial<CpAppointmentsResponseModel>) {
    Object.assign(this, init);
  }
}
